export default {"src":"/_next/static/media/lpdfi.42d1b292.svg","height":20,"width":20};